import react from "react";
import { Select } from "antd";

const CityFilter = ({ cities, citySearch, handleCityChange }) => {
    return (
        <Select
            value={citySearch}
            onChange={(e) => handleCityChange(e)}
            className="me-2"
            style={{ width: 200 }}
            showSearch
            filterOption={(input, option) => {
                // Fix 5: Better filter logic
                return (option?.label ?? "")
                    .toString()
                    .toLowerCase()
                    .includes(input.toLowerCase());
            }}
            allowClear
        >
            {cities.map((city) => (
                <Select.Option key={city.id} value={city.id}>{city.name}</Select.Option>
            ))}
        </Select>
    )
};

export default CityFilter;